import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import Picker from "./Picker";
import { Moment } from "moment-timezone";

const DatePickerToFrom = ({
  timestampFrom,
  onChangeFrom,
  timestampTo,
  onChangeTo,
  color,
  disabled,
  maxDays,
  disableTo,
}: {
  timestampFrom: Moment | null;
  onChangeFrom: (date: Moment | null) => void;
  timestampTo: Moment | null;
  onChangeTo: (date: Moment | null) => void;
  color?: string;
  disabled?: boolean;
  maxDays?: number | null; // maxDays is the number of days from today to restrict the from date
  disableTo?: boolean; // if true, the TO picker will not be displayed
}) => {
  // restrict from date to maxDays days from current date
  var date = new Date();
  if (maxDays != null) {
    date.setDate(date.getDate() - maxDays);
  }

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Picker
        label="FROM:"
        timestamp={timestampFrom}
        onChange={onChangeFrom}
        color={color}
        disabled={disabled}
        minDate={maxDays ? date : undefined}
      />
      {!disableTo && (
        <Picker
          label="TO:"
          timestamp={timestampTo}
          onChange={onChangeTo}
          color={color}
          disabled={disabled}
          minDate={timestampFrom}
        />
      )}
    </MuiPickersUtilsProvider>
  );
};

export default DatePickerToFrom;
